export const CONFIGURATOR_STORAGE_KEY = 'hestia.configurator.v1';
const TYPES = ['SINGLE_DOOR', 'DOOR_LEFT_SIDELIGHT', 'DOOR_RIGHT_SIDELIGHT', 'DOOR_TWO_SIDELIGHTS',
  'DOUBLE_DOOR', 'DOUBLE_DOOR_LEFT_SIDELIGHT', 'DOUBLE_DOOR_RIGHT_SIDELIGHT', 'DOUBLE_DOOR_TWO_SIDELIGHTS'];
const numeric = (value, fallback, min, max) => Number.isFinite(value) && value >= min && value <= max ? value : fallback;
const text = (value, fallback = '') => typeof value === 'string' && value.length <= 200 ? value : fallback;
const side = (value) => ({ widthMm: numeric(value?.widthMm, 400, 1, 5000),
  heightMm: value?.heightMm == null ? null : numeric(value.heightMm, null, 1, 5000),
  glassType: text(value?.glassType, 'CLEAR'),
  layout: ['FULL_GLASS', 'ONE_HORIZONTAL_DIVIDER', 'TWO_HORIZONTAL_DIVIDERS', 'CUSTOM'].includes(value?.layout) ? value.layout : 'FULL_GLASS' });

export function readConfiguratorState(urlFamily) {
  let saved, legacyFamily;
  try {
    const parsed = JSON.parse(localStorage.getItem(CONFIGURATOR_STORAGE_KEY) || 'null');
    if (parsed?.version === 1 && typeof parsed.familyId === 'string') saved = parsed;
    legacyFamily = localStorage.getItem('cfg.family');
  } catch { /* A blocked store or malformed old draft starts with defaults. */ }
  const familyId = text(urlFamily) || text(saved?.familyId) || text(legacyFamily) || '60_OUT';
  const restored = !!saved && saved.familyId === familyId;
  const s = restored ? saved : {};
  const config = Object.fromEntries(['design', 'colour', 'colourCode', 'glass', 'glassPattern', 'frame', 'threshold', 'lock', 'hinge', 'sidelight', 'cottagePattern']
    .filter(key => typeof s.config?.[key] === 'string').map(key => [key, text(s.config[key])]));
  const leafW = { l: numeric(s.leafW?.l, 450, 300, 1500), r: numeric(s.leafW?.r, 450, 300, 1500) };
  const confType = TYPES.includes(s.confType) ? s.confType : 'SINGLE_DOOR';
  return { restored, familyId, step: Math.round(numeric(s.step, 1, 1, 4)),
    width: confType.startsWith('DOUBLE_DOOR') ? leafW.l + leafW.r : numeric(s.width, 900, 1, 5000),
    leafW, height: numeric(s.height, 2100, 1, 5000), confType,
    slSame: typeof s.slSame === 'boolean' ? s.slSame : true, slLeft: side(s.slLeft), slRight: side(s.slRight),
    handing: s.handing === 'right' ? 'right' : 'left', opening: s.opening === 'inward' ? 'inward' : 'outward',
    config, studioDesignId: text(s.studioDesignId),
    extras: Array.isArray(s.extras) ? s.extras.filter(id => typeof id === 'string').slice(0, 30) : [],
    qty: Math.round(numeric(s.qty, 1, 1, 999)),
    openAngle: numeric(s.openAngle, 0, 0, 110), passiveAngle: numeric(s.passiveAngle, 0, 0, 110) };
}

export function writeConfiguratorState(state) {
  try { localStorage.setItem(CONFIGURATOR_STORAGE_KEY, JSON.stringify({ ...state, version: 1 })); }
  catch { /* Browsing still works when storage is unavailable. */ }
}
